import { isFunction } from "./is.js";
function getComponentResolver(fn) {
  return (resolve, cb) => {
    fn().then((module) => {
      const ResolvedClass = module.default ?? module;
      resolve(ResolvedClass);
      if (isFunction(cb)) {
        cb();
      }
    });
  };
}
export {
  getComponentResolver
};
//# sourceMappingURL=getComponentResolver.js.map
